import Badge from 'components/partials/badge/badje';
import {
  FlyoutContainer,
  FlyoutTooltip,
} from 'components/shared/side-menu/flyout-container';
import { useHoverFlyout } from 'components/shared/side-menu/hooks';

import type { NavItem } from 'components/shared/side-menu/nav-config';

import BaseNotificationBadge from './base-notification-badge';

interface BaseCollapsedTooltipProps {
  item: NavItem;
  baseItemClasses: string;
  isItemActive: boolean;
  renderLink: (props: Record<string, unknown>) => React.ReactNode;
  hasNotification?: boolean;
  onNavigate?: () => void;
}

const BaseCollapsedTooltip = ({
  item,
  baseItemClasses,
  isItemActive,
  renderLink,
  hasNotification = false,
  onNavigate,
}: BaseCollapsedTooltipProps) => {
  const { isHovered, flyoutTop, hoverProps } = useHoverFlyout();

  const linkContent = (
    <span className="relative" aria-hidden="true">
      {item.icon}
      <BaseNotificationBadge hasNotification={hasNotification} />
    </span>
  );

  return (
    <div {...hoverProps} className="relative flex justify-center">
      {renderLink({
        to: item.to,
        onClick: onNavigate,
        className: baseItemClasses,
        'aria-label': item.label,
        'aria-current': isItemActive ? 'page' : undefined,
        children: linkContent,
        'data-testid': `side-menu-item-${item.id}`,
      })}

      <FlyoutContainer
        isVisible={isHovered}
        top={flyoutTop}
        alignItems="items-center"
      >
        <FlyoutTooltip>
          <span className="flex items-center gap-2">
            {item.label}
            {item.badge && (
              <Badge text={item.badge} variant="neutral-outlined" />
            )}
          </span>
        </FlyoutTooltip>
      </FlyoutContainer>
    </div>
  );
};

export default BaseCollapsedTooltip;
